import { render, staticRenderFns } from "./ComboboxEixo.vue?vue&type=template&id=5c07c89e&scoped=true"
import script from "./ComboboxEixo.vue?vue&type=script&lang=js"
export * from "./ComboboxEixo.vue?vue&type=script&lang=js"
import style0 from "./ComboboxEixo.vue?vue&type=style&index=0&id=5c07c89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c07c89e",
  null
  
)

export default component.exports